// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1OMPL","box":"WorkspacesBox_box__3l4J2","node":"WorkspacesBox_node__jzP1d"};